import React from 'react';
import * as styles from './index.module.less';
import { PublicClose } from 'notta-web-icon';

interface IProp {
  onClose?: (e) => void;
}

const SwitchLanguageBanner = ({ onClose }: IProp) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.content_btn_wrapper}>
          <div className={styles.content_wrapper}>
            Change language to English or Japanese that applies to your location.
          </div>
          <div className={styles.btn_wrapper}>
            <a href="/" className={`${styles.page_btn} ${styles.jp}`}>
              日本語
            </a>
            <a href="/en" className={`${styles.page_btn} ${styles.en}`}>
              English
            </a>
          </div>
        </div>
        <button className={styles.close_btn} onClick={onClose}>
          <PublicClose />
        </button>
      </div>
    </div>
  );
};
export default SwitchLanguageBanner;
